import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'
import { getMTODeliveryDate } from '@components/product/MadeToOrderInfo/helpers'

type PageErrorProps = {
  createdAt?: string
  classes?: string
}

function MadeToOrderInfo({ createdAt, classes }: PageErrorProps) {
  const paraClasses = classNames(styles.mtoDispatch__info, classes)

  return (
    <p className={paraClasses}>
      <span className={styles.mtoDispatch__message}>Made to Order:</span>{' '}
      Estimated dispatch by {getMTODeliveryDate(createdAt)}
    </p>
  )
}

export default MadeToOrderInfo
